// 20 villes Seine-et-Marne avec slug SEO unique par ville
// Slugs variés pour éviter la duplication SEO
export const CITIES = [
  {
    name: "Melun",
    slug: "degraissage-hotte-melun",
    postal: "77000",
    h1Variant: "Dégraissage de Hotte à Melun",
    intro:
      "Spécialiste du dégraissage de hottes professionnelles à Melun (77000). Située au cœur de la Seine-et-Marne, Melun concentre une forte densité de restaurants, brasseries et cuisines collectives qui doivent répondre aux exigences strictes de l'arrêté du 25 juin 1980. Notre équipe technique intervient 7j/7 dans tout Melun, du quartier Saint-Aspais au quartier de l'Almont, en passant par la Préfecture et la zone d'activité.",
    keywords: "dégraissage hotte Melun, nettoyage hotte restaurant Melun 77000, nettoyage extraction cuisine Melun, entretien hotte professionnelle Melun",
    distance: "0 km",
    notableSpots: "Préfecture, Centre commercial 2 Fontaines, Quartier Saint-Aspais",
    lat: 48.5418, lng: 2.6597,
  },
  {
    name: "Le Mée-sur-Seine",
    slug: "nettoyage-hotte-le-mee-sur-seine",
    postal: "77350",
    h1Variant: "Nettoyage de Hotte Professionnelle au Mée-sur-Seine",
    intro:
      "Au Mée-sur-Seine (77350), commune limitrophe de Melun, nous accompagnons restaurateurs et gérants d'établissements de restauration rapide pour le nettoyage complet de leurs hottes et systèmes d'extraction. Notre équipe locale intervient en moins de 24h pour vous garantir la conformité hygiène et sécurité incendie.",
    keywords: "nettoyage hotte Le Mée-sur-Seine, dégraissage cuisine pro 77350, entretien extraction Mée-sur-Seine",
    distance: "4 km",
    notableSpots: "Centre commercial Boissise, Zone d'activité Plein-Ciel",
    lat: 48.5398, lng: 2.6240,
  },
  {
    name: "Dammarie-les-Lys",
    slug: "nettoyage-extraction-dammarie-les-lys",
    postal: "77190",
    h1Variant: "Nettoyage d'Extraction de Cuisine à Dammarie-les-Lys",
    intro:
      "Dammarie-les-Lys (77190) abrite de nombreux restaurants, pizzerias et établissements de restauration collective le long de l'avenue Charles-de-Gaulle et de la zone commerciale. Nous intervenons pour le nettoyage des gaines d'extraction, le dégraissage complet des hottes et la mise aux normes incendie.",
    keywords: "nettoyage extraction Dammarie-les-Lys, dégraissage hotte 77190, nettoyage gaine ventilation Dammarie",
    distance: "3 km",
    notableSpots: "Centre commercial Carré Sénart proche, Abbaye du Lys",
    lat: 48.5223, lng: 2.6320,
  },
  {
    name: "Vaux-le-Pénil",
    slug: "degraissage-hotte-vaux-le-penil",
    postal: "77000",
    h1Variant: "Dégraissage de Hotte à Vaux-le-Pénil",
    intro:
      "À Vaux-le-Pénil (77000), nous accompagnons les restaurants traditionnels, brasseries et cantines d'entreprise du parc d'activités. Notre intervention rapide garantit un dégraissage professionnel conforme aux exigences des assurances et de la DDPP de Seine-et-Marne.",
    keywords: "dégraissage hotte Vaux-le-Pénil, nettoyage hotte restaurant 77000, entretien cuisine pro Vaux-le-Pénil",
    distance: "5 km",
    notableSpots: "Parc d'activités de Vaux-le-Pénil, Centre culturel La Ferme des Jeux",
    lat: 48.5350, lng: 2.6906,
  },
  {
    name: "Savigny-le-Temple",
    slug: "nettoyage-hotte-savigny-le-temple",
    postal: "77176",
    h1Variant: "Nettoyage de Hotte à Savigny-le-Temple",
    intro:
      "Savigny-le-Temple (77176), située à proximité de Sénart, accueille une grande variété de restaurants et de cuisines collectives. Notre équipe intervient pour le nettoyage haute pression des hottes, le décrassage des filtres et la vérification complète des conduits d'extraction.",
    keywords: "nettoyage hotte Savigny-le-Temple, dégraissage cuisine 77176, nettoyage extraction Savigny",
    distance: "13 km",
    notableSpots: "Sénart, Carré Sénart, Quartier du Plessis-le-Roi",
    lat: 48.5847, lng: 2.5836,
  },
  {
    name: "Cesson",
    slug: "degraissage-hotte-cesson",
    postal: "77240",
    h1Variant: "Dégraissage de Hotte à Cesson",
    intro:
      "À Cesson (77240), nous nettoyons les hottes et systèmes d'extraction des restaurants et cuisines professionnelles avec un service 7j/7. Notre intervention discrète et nocturne permet de ne pas interrompre votre service.",
    keywords: "dégraissage hotte Cesson 77240, nettoyage hotte restaurant Cesson, nettoyage gaine extraction",
    distance: "8 km",
    notableSpots: "Zone d'activités de Cesson, Centre-ville",
    lat: 48.5689, lng: 2.5942,
  },
  {
    name: "Vert-Saint-Denis",
    slug: "nettoyage-hotte-vert-saint-denis",
    postal: "77240",
    h1Variant: "Nettoyage de Hotte à Vert-Saint-Denis",
    intro:
      "Vert-Saint-Denis (77240) compte plusieurs restaurants et établissements de restauration que nous accompagnons pour le nettoyage complet de leur système d'extraction. Notre attestation officielle est reconnue par les assurances.",
    keywords: "nettoyage hotte Vert-Saint-Denis, dégraissage 77240, entretien hotte professionnelle",
    distance: "10 km",
    notableSpots: "Pôle Galilée, Centre commercial",
    lat: 48.5683, lng: 2.5664,
  },
  {
    name: "Rubelles",
    slug: "degraissage-hotte-rubelles",
    postal: "77950",
    h1Variant: "Dégraissage de Hotte à Rubelles",
    intro:
      "À Rubelles (77950), commune résidentielle de l'agglomération de Melun, nous intervenons pour les restaurants et traiteurs locaux qui souhaitent garantir une cuisine hygiénique et sans risque d'incendie.",
    keywords: "dégraissage hotte Rubelles 77950, nettoyage cuisine pro Rubelles, hotte restaurant Melun nord",
    distance: "4 km",
    notableSpots: "Église Sainte-Croix, proche de Melun",
    lat: 48.5573, lng: 2.6766,
  },
  {
    name: "La Rochette",
    slug: "nettoyage-hotte-la-rochette",
    postal: "77000",
    h1Variant: "Nettoyage de Hotte à La Rochette",
    intro:
      "La Rochette (77000), petite commune au sud de Melun, accueille restaurants et traiteurs que nous accompagnons dans leur démarche de mise en conformité hygiène et incendie.",
    keywords: "nettoyage hotte La Rochette, dégraissage 77000, hotte restaurant Melun sud",
    distance: "3 km",
    notableSpots: "Berges de Seine, proche de Melun",
    lat: 48.5226, lng: 2.6612,
  },
  {
    name: "Moissy-Cramayel",
    slug: "degraissage-hotte-moissy-cramayel",
    postal: "77550",
    h1Variant: "Dégraissage de Hotte à Moissy-Cramayel",
    intro:
      "Moissy-Cramayel (77550), située dans la communauté d'agglomération Grand Paris Sud, regroupe de nombreux restaurants d'entreprise et restaurants traditionnels. Nous dégraissons hottes, filtres et conduits pour vous garantir une conformité totale.",
    keywords: "dégraissage hotte Moissy-Cramayel 77550, nettoyage cuisine pro, hotte Sénart",
    distance: "15 km",
    notableSpots: "Parc d'activités de Sénart, Quartier de la Bastide",
    lat: 48.6244, lng: 2.5878,
  },
  {
    name: "Combs-la-Ville",
    slug: "nettoyage-hotte-combs-la-ville",
    postal: "77380",
    h1Variant: "Nettoyage de Hotte à Combs-la-Ville",
    intro:
      "À Combs-la-Ville (77380), nous nettoyons les hottes et systèmes d'extraction des restaurants traditionnels, fast-foods et cuisines centrales avec un service personnalisé et un délai d'intervention rapide.",
    keywords: "nettoyage hotte Combs-la-Ville 77380, dégraissage restaurant, hotte cuisine pro",
    distance: "20 km",
    notableSpots: "Centre-ville, Parc de la Coulée Verte",
    lat: 48.6695, lng: 2.5631,
  },
  {
    name: "Lieusaint",
    slug: "degraissage-hotte-lieusaint",
    postal: "77127",
    h1Variant: "Dégraissage de Hotte à Lieusaint",
    intro:
      "Lieusaint (77127), au cœur de la zone commerciale Carré Sénart, regroupe restaurants de chaînes et indépendants. Notre équipe intervient en horaires décalés pour ne pas perturber votre activité commerciale.",
    keywords: "dégraissage hotte Lieusaint 77127, nettoyage Carré Sénart, hotte restaurant",
    distance: "17 km",
    notableSpots: "Carré Sénart, Allée Royale",
    lat: 48.6258, lng: 2.5500,
  },
  {
    name: "Fontainebleau",
    slug: "nettoyage-hotte-fontainebleau",
    postal: "77300",
    h1Variant: "Nettoyage de Hotte à Fontainebleau",
    intro:
      "Fontainebleau (77300), ville touristique et historique, abrite hôtels, restaurants étoilés, brasseries et cuisines de palais. Nous proposons un service haut de gamme adapté aux exigences des établissements premium.",
    keywords: "nettoyage hotte Fontainebleau 77300, dégraissage hôtel restaurant, hotte professionnelle Fontainebleau",
    distance: "18 km",
    notableSpots: "Château de Fontainebleau, Quartier du Bréau",
    lat: 48.4078, lng: 2.7019,
  },
  {
    name: "Avon",
    slug: "degraissage-hotte-avon",
    postal: "77210",
    h1Variant: "Dégraissage de Hotte à Avon",
    intro:
      "À Avon (77210), commune jumelée à Fontainebleau, nous nettoyons les hottes des restaurants, brasseries et cuisines collectives avec un service professionnel et discret.",
    keywords: "dégraissage hotte Avon 77210, nettoyage restaurant Fontainebleau Avon, hotte cuisine pro",
    distance: "20 km",
    notableSpots: "Gare d'Avon-Fontainebleau, Centre-ville",
    lat: 48.4097, lng: 2.7203,
  },
  {
    name: "Bois-le-Roi",
    slug: "nettoyage-hotte-bois-le-roi",
    postal: "77590",
    h1Variant: "Nettoyage de Hotte à Bois-le-Roi",
    intro:
      "Bois-le-Roi (77590), village forestier en bord de Seine, accueille restaurants gastronomiques et guinguettes. Notre intervention spécialisée préserve la qualité de service de ces établissements prestigieux.",
    keywords: "nettoyage hotte Bois-le-Roi 77590, dégraissage restaurant gastronomique, hotte cuisine",
    distance: "12 km",
    notableSpots: "Base de loisirs, Bord de Seine",
    lat: 48.4759, lng: 2.6925,
  },
  {
    name: "Chartrettes",
    slug: "degraissage-hotte-chartrettes",
    postal: "77590",
    h1Variant: "Dégraissage de Hotte à Chartrettes",
    intro:
      "À Chartrettes (77590), nous nettoyons hottes et systèmes d'extraction des restaurants au bord de Seine et des établissements de réception qui font la réputation de la commune.",
    keywords: "dégraissage hotte Chartrettes 77590, nettoyage cuisine, hotte restaurant Seine",
    distance: "15 km",
    notableSpots: "Bord de Seine, Centre historique",
    lat: 48.4831, lng: 2.7039,
  },
  {
    name: "Le Châtelet-en-Brie",
    slug: "nettoyage-hotte-le-chatelet-en-brie",
    postal: "77820",
    h1Variant: "Nettoyage de Hotte au Châtelet-en-Brie",
    intro:
      "Au Châtelet-en-Brie (77820), nous intervenons auprès des restaurants ruraux, fermes-auberges et traiteurs pour le dégraissage complet de leur installation de cuisine professionnelle.",
    keywords: "nettoyage hotte Châtelet-en-Brie 77820, dégraissage cuisine, hotte ferme-auberge",
    distance: "18 km",
    notableSpots: "Église Saint-Pierre, Forêt de Villefermoy",
    lat: 48.5106, lng: 2.7906,
  },
  {
    name: "Nangis",
    slug: "degraissage-hotte-nangis",
    postal: "77370",
    h1Variant: "Dégraissage de Hotte à Nangis",
    intro:
      "Nangis (77370), commune dynamique de Seine-et-Marne, compte de nombreux établissements de restauration que nous accompagnons pour leur conformité hygiène et incendie.",
    keywords: "dégraissage hotte Nangis 77370, nettoyage hotte restaurant, hotte cuisine pro Nangis",
    distance: "28 km",
    notableSpots: "Marché de Nangis, Zone industrielle",
    lat: 48.5505, lng: 3.0083,
  },
  {
    name: "Montereau-Fault-Yonne",
    slug: "nettoyage-hotte-montereau-fault-yonne",
    postal: "77130",
    h1Variant: "Nettoyage de Hotte à Montereau-Fault-Yonne",
    intro:
      "Montereau-Fault-Yonne (77130), au confluent de la Seine et de l'Yonne, accueille de nombreux restaurants, brasseries et cuisines collectives. Notre équipe intervient régulièrement pour le dégraissage complet de leurs installations.",
    keywords: "nettoyage hotte Montereau 77130, dégraissage cuisine, hotte restaurant Montereau-Fault-Yonne",
    distance: "30 km",
    notableSpots: "Confluence Seine-Yonne, Centre commercial",
    lat: 48.3859, lng: 2.9533,
  },
  {
    name: "Moret-Loing-et-Orvanne",
    slug: "degraissage-hotte-moret-loing-et-orvanne",
    postal: "77250",
    h1Variant: "Dégraissage de Hotte à Moret-Loing-et-Orvanne",
    intro:
      "Moret-Loing-et-Orvanne (77250), cité médiévale chère à Alfred Sisley, abrite restaurants gastronomiques et auberges. Nous proposons un service discret et haut de gamme pour ces établissements de caractère.",
    keywords: "dégraissage hotte Moret-Loing-et-Orvanne 77250, nettoyage restaurant gastronomique, hotte auberge",
    distance: "25 km",
    notableSpots: "Cité médiévale, Bord du Loing",
    lat: 48.3736, lng: 2.8133,
  },
];

export const findCityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
